import { render, staticRenderFns } from "./AppTabs.vue?vue&type=template&id=4523f2ce&scoped=true"
import script from "./AppTabs.vue?vue&type=script&lang=js"
export * from "./AppTabs.vue?vue&type=script&lang=js"
import style0 from "./AppTabs.vue?vue&type=style&index=0&id=4523f2ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4523f2ce",
  null
  
)

export default component.exports